module.exports = __webpack_public_path__ + "img/bonus-anual.830c34aa.png";